<template>
    <div class="list">
        <div class="item"
            :class="itemClassName"
            v-for="item in list"
            :key="item.id">
                <div class="item-icon box box--space-bottom-s">
                    <div>
                        <i class="mm-hp-icon-3x text--colored"
                            :class="item.icon" />
                    </div>
                </div>
                <div class="item-text">
                    <span class="text--bigger-paragraph">{{item.name}}</span>
                </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        itemClassName: {
            type: String
        },
        list: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .list {
        display: flex;
        flex-wrap: wrap;
    }

    .item {
        padding:  2rem 0;
    }

    .text--medium-weight {
        font-size: 1.6rem;
        line-height: 2.4rem;
    }

    @media (max-width: 576px) {
        .item {
            display: flex;
        }

        .item-icon {
            margin-bottom: 0px !important;
            padding-right: 3rem;
            flex-basis: 0;
        }

        .item-text {
            width: 50%;
            padding-right: 2rem;
            margin-bottom: 0rem;
            flex-grow: 1;
            flex-basis: 0;
        }
    }

</style>